import * as pdfjsLib from "pdfjs-dist/build/pdf";

// Built by webpack as a real worker bundle (new Worker(new URL(...))) so the
// worker loads from the app's own build output. Referencing it as a plain
// asset URL breaks production builds: Babel injects bare require() calls for
// @babel/runtime helpers that a browser worker cannot resolve.
// One shared PDFWorker is passed explicitly to getDocument so pdf.destroy()
// doesn't tear it down while other thumbnails are still rendering.
let pdfWorker = null;
const getPdfWorker = () => {
  if (!pdfWorker) {
    pdfWorker = new pdfjsLib.PDFWorker({
      port: new Worker(new URL("pdfjs-dist/build/pdf.worker.min.js", import.meta.url)),
    });
  }
  return pdfWorker;
};

/**
 * Renders the first page of a PDF (File/Blob or URL) to a PNG data URL.
 * @param {File|Blob|string} source
 * @param {{ maxWidth?: number }} [options]
 * @returns {Promise<string>} PNG data URL of the rendered first page
 */
export const getPdfFirstPageThumbnail = async (source, { maxWidth = 300 } = {}) => {
  const worker = getPdfWorker();
  const loadingTask =
    source instanceof Blob
      ? pdfjsLib.getDocument({ data: await source.arrayBuffer(), worker })
      : pdfjsLib.getDocument({ url: source, worker });

  const pdf = await loadingTask.promise;
  try {
    const page = await pdf.getPage(1);
    const baseViewport = page.getViewport({ scale: 1 });
    const scale = maxWidth / baseViewport.width;
    const viewport = page.getViewport({ scale });

    const canvas = document.createElement("canvas");
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    const context = canvas.getContext("2d");

    await page.render({ canvasContext: context, viewport }).promise;
    return canvas.toDataURL("image/png");
  } finally {
    pdf.destroy();
  }
};
